<template>
    <div id="gb_viewer_feed" class="  align-content-around flex-wrap" style="height:400px; border: 1px ">
        <div
            style="font-size:medium; border-top-left-radius: 20px;border-top-right-radius: 20px;width:100%;text-align: center; color:white; padding: 5px; background-color: rgb(22, 22, 22);">
            Timeline</div>
            
          <!-- <div hidden class="GBcontainer" style="color:white">
              <div class="GBcol text-center" style="background-color:grey; padding:0.3rem; cursor: pointer">
             All
          </div>
              <div v-for="(team, index) in eventData.teams" :key="index" class="GBcol ">
             <div class="GBcol text-center" style="padding:0.3rem; cursor: pointer" v-bind:style="'background-color: '+(team.color ? team.color : 'black')+';'">
              {{ team.name}}
          </div>
          </div>
          </div> -->
        <div id="timeline_feed"
            style="width: 100%; height:100%;  background-color: rgb(243, 243, 243);overflow-y: scroll; padding:10px; ">
          <div v-for="(event, index) in eventData.events" :key="index">
            <div v-bind:style="'border-left: 2px solid '+(eventData.teams[event.teamID] ?eventData.teams[event.teamID].color : 'black')+';'" class="w-100 d-flex align-items-center p-2 timeline_box" >
      
                <div class=" timeline_time">{{ new Date(event.time*1000).toLocaleTimeString()}}</div>
                <div class="timeline_text">{{ (eventData.teams[event.teamID] ? eventData.teams[event.teamID].name : "Global") + ": "+event.description}}<br /><span class="timeline_small">{{ eventData.teams.length == 2 ? eventData.teams[0].name +" "+ eventData.teams[0].score+ " - "+ eventData.teams[1].score +" "+ eventData.teams[1].name : event.scores}}</span></div>
            </div>
            </div>

                   <div class="w-100 d-flex align-items-center p-2 timeline_box" v-if="eventData.events.length == 0">
              
                <div class=" timeline_time">-</div>
                <div class="timeline_text">Event has no events<br /></div>
            </div>
        </div>
        
    </div>
</template>
<script>
  export default {
     props: ['teams','eventData' , 'isLive'],
  }
</script>

<style scoped>
.leftBanner {
   /* width: 10%; height:100%;  */
    /* clip-path: polygon(0 0, 100% 0, 0 100%); */
    clip-path: polygon(100% 50%, 0% 100%, 0 0);
    /* clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%); */
}
.rightBanner {
    /* width: 10%; height:100%; */
    /* clip-path: polygon(0 0, 100% 0, 100% 100%); */
    clip-path: polygon(100% 0, 0 50%, 100% 100%);
}

.timeline_time {
    padding: 8px;
    font-size: small;
    border-right: 1px solid rgb(206, 206, 206);
   
    color: rgb(105, 105, 105);
  
}
.timeline_text {
    padding: 5px;
    font-weight: bold;
    text-align: center;
    width: 100%;
}

.timeline_small{
    font-weight: normal;
    font-size: 0.8em;
}

.timeline_box {
    background-color: white;
    border-radius: 5px;
    margin-top: 5px;
  
}
.timeline_watch {
    padding: 5px;
    color: darkblue;
    text-align: center;
    font-size: smaller;
    cursor: pointer;

}
.timeline_feed {
    padding:5px;
}

.GBcontainer {
  display: flex; /* or inline-flex */
}

.GBcol {
  flex-grow: 1;

}

.GBcol2x {
  flex-grow: 2;

}
</style>